import React from 'react';

import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function RegenerateAPITokenModal({ onClose, onRegenerate }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'settings.externalIntegrationConfiguration.components.RegenerateAPITokenModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={onRegenerate}>
            {i18nT('confirm')}
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-8'>
        <h2 className='tw-mb-4 tw-mt-0 tw-text-l tw-font-semibold tw-text-grey-900'>
          {i18nT('body.title')}
        </h2>
        <Trans
          components={{
            firstParagraph: <p className='tw-m-0 tw-mb-2 tw-p-0' />,
            secondParagraph: <p className='tw-m-0 tw-p-0' />,
          }}
          i18nKey='settings.externalIntegrationConfiguration.components.RegenerateAPITokenModal.body.content'
          ns='components'
        />
      </div>
    </ModalBox>
  );
}

RegenerateAPITokenModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onRegenerate: PropTypes.func.isRequired,
};
